var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "formValidation",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ invalid }) {
          return [
            _c(
              "form",
              {
                ref: "container",
                staticClass: "form-horizontal p-t-10 p-b-10",
                attrs: {
                  name: "blockCallerNumber",
                  role: "form",
                  novalidate: ""
                },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c("ValidationProvider", {
                  attrs: { rules: "required", slim: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors, classes }) {
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.number.phoneNumber,
                                  expression: "number.phoneNumber"
                                }
                              ],
                              class: classes,
                              attrs: { type: "hidden", name: "phoneNumber" },
                              domProps: { value: _vm.number.phoneNumber },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.number,
                                    "phoneNumber",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    { staticClass: "col-sm-3 col-md-3 control-label" },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SELECT_CAMPAIGN_LABEL")) + "\n        "
                      ),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.right",
                              value: _vm.$t("SELECT_CAMPAIGN_TT"),
                              expression: "$t('SELECT_CAMPAIGN_TT')",
                              modifiers: { right: true }
                            }
                          ]
                        },
                        [
                          _vm._v("\n            "),
                          _c("i", { staticClass: "fa fa-question-circle" })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-5 col-md-3" },
                    [
                      _c("SearchableDropdown", {
                        attrs: {
                          config: _vm.campaignsDropdownConfig,
                          rules: "required",
                          disabled: ""
                        },
                        model: {
                          value: _vm.number.campaignId,
                          callback: function($$v) {
                            _vm.$set(_vm.number, "campaignId", $$v)
                          },
                          expression: "number.campaignId"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-xs-12 col-sm-3 col-md-3 control-label"
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SPECIFY_DURATION_LABEL")) + "\n        "
                      ),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.right",
                              value: _vm.$t("SPECIFY_DURATION_TT"),
                              expression: "$t('SPECIFY_DURATION_TT')",
                              modifiers: { right: true }
                            }
                          ]
                        },
                        [
                          _vm._v("\n            "),
                          _c("i", { staticClass: "fa fa-question-circle" })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xs-6 col-sm-2 col-md-1" },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: "min_value:1", slim: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors, classes }) {
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.number.expInHour,
                                        expression: "number.expInHour"
                                      }
                                    ],
                                    staticClass: "form-control m-b-0",
                                    class: classes,
                                    attrs: {
                                      name: "timePeriod",
                                      type: "number",
                                      min: "1",
                                      placeholder: _vm.$t("DURATION_HOURS_UNIT")
                                    },
                                    domProps: { value: _vm.number.expInHour },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.number,
                                          "expInHour",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-offset-3 col-md-offset-3 col-md-8 col-sm-8"
                    },
                    [
                      _c(
                        "PrimaryButton",
                        {
                          attrs: {
                            size: "sm",
                            disabled: invalid,
                            "show-loader-on-form": _vm.showLoader
                          },
                          on: { click: _vm.blockNumberSubmit }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("BLOCK_NUMBER")) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("button", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "CANCEL",
                            expression: "'CANCEL'"
                          }
                        ],
                        staticClass: "btn btn-sm btn-danger m-l-15",
                        attrs: {
                          type: "button",
                          name: "blockCallerNumberCancelButton"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("closeForm")
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }